/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import EtapasCM from '../controladorModelo/etapasCM';
import { IFormularioEtapasCVProps } from '../interfaces';
import { acciones, IEstadoEtapas } from '../reductorEtapas';
import FormularioEtapasVista from '../vista/formularioEtapasVista';
import { useSelector } from 'react-redux';

const estadoInicial: IEtapas = {
    Estado: 1,
    EtapaDescripcion: '',
    EtapaId: 0,
};
const etapasCM = new EtapasCM();

const FormularioEtapasCV: React.FunctionComponent<IFormularioEtapasCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadEtapas }, dispatch] = useProveedor<IEstadoEtapas>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IEtapas>(estadoInicial);

    React.useEffect(() => {
        if (entidadEtapas && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadEtapas);
        } else {
            reiniciar();
        }
    }, [entidadEtapas]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionEtapas = () => {
        if (etapasCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarEtapas,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarEtapas = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            etapasCM
                .crearEtapas({
                    ...valor,
                    EmpresaId: IdEmpresa,
                    AgenciaId: idAgencia,
                    Estado: valor.Estado ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            etapasCM
                .editarEtapas({
                    ...valor,
                    EmpresaId: IdEmpresa,
                    AgenciaId: idAgencia,
                    Estado: valor.Estado ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioEtapasVista
            accionCrearEditar={confirmarCreacionEdicionEtapas}
            cambiarInfoFomulario={alCambiarValor}
            etapas={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioEtapasCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioEtapasCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioEtapasCV);
